import createSvgIcon from '../Utils/CreateSvgIcon';

export const BodyColorBeige = createSvgIcon(
  <circle cx="10" cy="10" fill="#F5F5DC" r="10" transform="matrix(1 0 0 -1 2 22)" />,
  'BodyColorBlack',
);
